(function() {
  "use strict";

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function initAtelier() {
    var sections = Array.prototype.slice.call(document.querySelectorAll("[data-p11-atelier3d]"));
    if (!sections.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;
    var activeSections = [];
    var frameId = null;

    sections.forEach(function(section) {
      section._p11PointerX = 0;
      section._p11PointerY = 0;
      section._p11TargetX = 0;
      section._p11TargetY = 0;

      var stage = section.querySelector(".p11-atelier3d__stage");
      var target = stage || section;

      function setPointer(event) {
        var rect = target.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        section._p11TargetX = clamp((event.clientX - rect.left) / rect.width - 0.5, -0.5, 0.5);
        section._p11TargetY = clamp((event.clientY - rect.top) / rect.height - 0.5, -0.5, 0.5);
        section.classList.add("is-interacting");
        start();
      }

      target.addEventListener("pointermove", setPointer, { passive: true });
      target.addEventListener("pointerdown", setPointer, { passive: true });

      target.addEventListener("pointerleave", function() {
        section._p11TargetX = 0;
        section._p11TargetY = 0;
        section.classList.remove("is-interacting");
      });
    });

    function render(now) {
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      activeSections.forEach(function(section) {
        var rail = section.querySelector(".p11-atelier3d__rail");
        if (!rail) return;
        var rect = section.getBoundingClientRect();
        var visible = rect.bottom > 0 && rect.top < viewport;
        var progress = clamp((viewport - rect.top) / (viewport + rect.height), 0, 1);
        section._p11PointerX += ((section._p11TargetX || 0) - (section._p11PointerX || 0)) * 0.16;
        section._p11PointerY += ((section._p11TargetY || 0) - (section._p11PointerY || 0)) * 0.16;
        var pulse = visible ? Math.sin((now || 0) / 1250) : 0;
        var lift = visible ? Math.cos((now || 0) / 1550) : 0;
        var pointerX = section._p11PointerX || 0;
        var pointerY = section._p11PointerY || 0;
        var tiltY = -24 + progress * 42 + pulse * 5.8 + pointerX * 34;
        var tiltX = 11 - progress * 10 + lift * 2.4 - pointerY * 24;
        rail.style.setProperty("--p11-tilt-y", tiltY.toFixed(2) + "deg");
        rail.style.setProperty("--p11-tilt-x", tiltX.toFixed(2) + "deg");
        rail.style.setProperty("--p11-float", (lift * 12).toFixed(2) + "px");
        rail.style.setProperty("--p11-pointer-x", (pointerX * 44).toFixed(2) + "px");
        rail.style.setProperty("--p11-pointer-y", (pointerY * 32).toFixed(2) + "px");
      });
    }

    var ticking = false;
    function requestRender() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function() {
        render(performance.now());
        ticking = false;
      });
    }

    function animate(now) {
      if (!activeSections.length) {
        frameId = null;
        return;
      }
      render(now);
      frameId = window.requestAnimationFrame(animate);
    }

    function start() {
      if (!frameId && activeSections.length) {
        frameId = window.requestAnimationFrame(animate);
      }
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var section = entry.target;
          var index = activeSections.indexOf(section);
          if (entry.isIntersecting && index === -1) {
            activeSections.push(section);
          } else if (!entry.isIntersecting && index !== -1) {
            activeSections.splice(index, 1);
          }
        });
        start();
      }, { rootMargin: "160px 0px" });

      sections.forEach(function(section) { observer.observe(section); });
    } else {
      activeSections = sections.slice();
      start();
    }

    window.addEventListener("scroll", requestRender, { passive: true });
    window.addEventListener("resize", requestRender);
  }

  function initProductCards() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("p11-card-3d-ready");

    var cards = Array.prototype.slice.call(document.querySelectorAll(".card-wrapper"));
    cards.forEach(function(card) {
      card.addEventListener("pointermove", function(event) {
        var rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty("--p11-card-y", (x * 7).toFixed(2) + "deg");
        card.style.setProperty("--p11-card-x", (y * -6).toFixed(2) + "deg");
      });

      card.addEventListener("pointerleave", function() {
        card.style.removeProperty("--p11-card-y");
        card.style.removeProperty("--p11-card-x");
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      initAtelier();
      initProductCards();
    });
  } else {
    initAtelier();
    initProductCards();
  }
})();
